"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var trans_1 = __importDefault(require("@/plugins/trans"));
var MailOutline_1 = __importDefault(require("@mui/icons-material/MailOutline"));
var Settings_1 = __importDefault(require("@mui/icons-material/Settings"));
var Apartment_1 = __importDefault(require("@mui/icons-material/Apartment"));
var Person_1 = __importDefault(require("@mui/icons-material/Person"));
var Line_1 = __importDefault(require("../components/Line"));
var Link_1 = __importDefault(require("../components/Link"));
var ArrowRightIcon_1 = __importDefault(require("../icons/ArrowRightIcon"));
var Vector_1 = __importDefault(require("../icons/Vector"));
var UserContext_1 = __importDefault(require("../context/UserContext"));
var BookmarkedContext_1 = __importDefault(require("../context/BookmarkedContext"));
var bookmarkedBubbleStyle_1 = __importDefault(require("./bookmarkedBubbleStyle"));
var PREFIX = 'MobileMenu';
var classes = {
    link: "".concat(PREFIX, "-link"),
    container: "".concat(PREFIX, "-container"),
    containerContainer: "".concat(PREFIX, "-containerContainer"),
    links: "".concat(PREFIX, "-links"),
    button: "".concat(PREFIX, "-button"),
    register: "".concat(PREFIX, "-register"),
    spacing: "".concat(PREFIX, "-spacing"),
    authContainer: "".concat(PREFIX, "-authContainer"),
    iconSpacing: "".concat(PREFIX, "-iconSpacing"),
    userImage: "".concat(PREFIX, "-userImage"),
    dashboard: "".concat(PREFIX, "-dashboard"),
};
var Root = (0, styles_1.styled)('div')(function (_a) {
    var _b;
    var palette = _a.theme.palette;
    return (_b = {},
        _b["& .".concat(classes.link)] = {
            marginLeft: '1rem',
            display: 'flex',
            alignItems: 'center',
        },
        _b["&.".concat(classes.container)] = {
            display: 'flex',
            flexDirection: 'column',
            position: 'fixed',
            top: 51,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: 'white',
            zIndex: 1500,
        },
        _b["& .".concat(classes.containerContainer)] = {
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
        },
        _b["& .".concat(classes.links)] = {
            display: 'flex',
            flexDirection: 'column',
            margin: '1.6rem 0',
            '&>*+*': {
                marginTop: '1.5rem',
            },
        },
        _b["& .".concat(classes.button)] = {
            border: "1px solid ".concat(palette.primary.dark),
            borderRadius: 50,
            display: 'flex',
            padding: '0.6rem',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'white',
        },
        _b["& .".concat(classes.register)] = {
            backgroundColor: palette.primary.dark,
            color: 'white',
            border: 'none',
            borderRadius: 25,
        },
        _b["& .".concat(classes.spacing)] = {
            '&>*+*': {
                marginLeft: '1rem',
            },
        },
        _b["& .".concat(classes.authContainer)] = {
            zIndex: 1,
            margin: 'auto 0 1.5rem 0',
            '&>*+*': {
                marginTop: '1rem',
            },
        },
        _b["& .".concat(classes.iconSpacing)] = {
            marginRight: '1rem',
        },
        _b["& .".concat(classes.userImage)] = {
            width: 35,
            height: 35,
            objectFit: 'cover',
            borderRadius: '50%',
        },
        _b["& .".concat(classes.dashboard)] = {
            display: 'inline-flex',
            color: 'black',
            alignItems: 'center',
            textDecoration: 'none',
        },
        _b);
});
var MobileMenu = function (_a) {
    var onLinkClicked = _a.onLinkClicked;
    var _b = (0, react_1.useContext)(UserContext_1.default), userId = _b.userId, userImageSrc = _b.userImageSrc, isAdmin = _b.isAdmin;
    var bookmarks = (0, react_1.useContext)(BookmarkedContext_1.default).bookmarks;
    var isVacanciesPage = (0, react_router_dom_1.useMatch)('/vacancies');
    var isYourVacanciesPage = (0, react_router_dom_1.useMatch)('/saved-vacancies');
    return ((0, jsx_runtime_1.jsxs)(Root, __assign({ className: classes.container }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Container, __assign({ className: classes.containerContainer }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: classes.links }, { children: [(0, jsx_runtime_1.jsx)(Link_1.default, __assign({ onClick: onLinkClicked, hide: !!isVacanciesPage, shouldBeExact: false, className: classes.link, to: "/vacancies" }, { children: trans_1.default.get('entities.vacancies') })), (0, jsx_runtime_1.jsxs)(Link_1.default, __assign({ onClick: onLinkClicked, hide: !!isYourVacanciesPage, className: classes.link, sx: { position: 'relative', display: 'flex', gap: '12px' }, to: "/saved-vacancies" }, { children: [trans_1.default.get('labels.frontend.general.saved_vacancies'), (bookmarks === null || bookmarks === void 0 ? void 0 : bookmarks.size) ? (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: bookmarkedBubbleStyle_1.default }, { children: bookmarks.size })) : ''] })), !!userId && ((0, jsx_runtime_1.jsx)(Link_1.default, __assign({ asAnchor: true, className: classes.link, to: "/applications/active" }, { children: trans_1.default.get('labels.frontend.general.my_applications') }))), (0, jsx_runtime_1.jsx)(Line_1.default, {}), !!userId && ((0, jsx_runtime_1.jsxs)(Link_1.default, __assign({ onClick: onLinkClicked, asAnchor: true, to: "/account", className: classes.link }, { children: [userImageSrc ? ((0, jsx_runtime_1.jsx)("img", { src: userImageSrc, className: (0, classnames_1.default)(classes.userImage, classes.iconSpacing) })) : ((0, jsx_runtime_1.jsx)(Person_1.default, { fontSize: "large", className: classes.iconSpacing, sx: { color: 'black' } })), trans_1.default.get('entities.profile')] }))), (0, jsx_runtime_1.jsxs)(Link_1.default, __assign({ onClick: onLinkClicked, to: "/vacancy-alerts", className: classes.link }, { children: [(0, jsx_runtime_1.jsx)(MailOutline_1.default, { fontSize: "large", className: classes.iconSpacing, sx: { color: 'black' } }), trans_1.default.get('alerts.general.alerts')] })), !!userId && ((0, jsx_runtime_1.jsxs)(Link_1.default, __assign({ asAnchor: true, to: "/organization", className: (0, classnames_1.default)(classes.link, classes.dashboard) }, { children: [(0, jsx_runtime_1.jsx)(Apartment_1.default, { fontSize: "large", className: classes.iconSpacing, sx: { color: 'black' } }), trans_1.default.get('labels.frontend.general.organization_dashboard')] }))), isAdmin && ((0, jsx_runtime_1.jsxs)(Link_1.default, __assign({ asAnchor: true, to: "/admin/dashboard", className: (0, classnames_1.default)(classes.link, classes.dashboard) }, { children: [(0, jsx_runtime_1.jsx)(Settings_1.default, { fontSize: "large", className: classes.iconSpacing, sx: { color: 'black' } }), "Beheer"] })))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: classes.authContainer }, { children: !userId ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Link_1.default, __assign({ onClick: onLinkClicked, asAnchor: true, className: (0, classnames_1.default)(classes.button, classes.register, classes.spacing), to: "/register" }, { children: [trans_1.default.get('labels.frontend.auth.register_button'), (0, jsx_runtime_1.jsx)(ArrowRightIcon_1.default, { style: { marginLeft: 8, stroke: 'white' } })] })), (0, jsx_runtime_1.jsxs)(Link_1.default, __assign({ onClick: onLinkClicked, asAnchor: true, className: classes.button, to: "/login" }, { children: [trans_1.default.get('labels.frontend.auth.login_button'), (0, jsx_runtime_1.jsx)(ArrowRightIcon_1.default, { style: { marginLeft: 8, stroke: '#FF4F6B' } })] }))] })) : ((0, jsx_runtime_1.jsxs)(Link_1.default, __assign({ onClick: onLinkClicked, asAnchor: true, className: classes.button, to: "/logout" }, { children: [trans_1.default.get('labels.frontend.auth.logout_button'), (0, jsx_runtime_1.jsx)(ArrowRightIcon_1.default, { style: { marginLeft: 8, stroke: '#FF4F6B' } })] }))) }))] })), (0, jsx_runtime_1.jsx)(Vector_1.default, {})] })));
};
exports.default = MobileMenu;
